import { api } from './api.js';

const enc = encodeURIComponent;

/** Avaliações verificadas: o cliente avalia o serviço registrado; a oficina responde. */
export const reviews = {
  pending: () => api('GET', '/v1/reviews/pending'),
  mine: () => api('GET', '/v1/reviews/mine'),
  tags: () => api('GET', '/v1/reviews/tags'),
  create: (body) => api('POST', '/v1/reviews', body),
  update: (id, patch) => api('PATCH', `/v1/reviews/${enc(id)}`, patch),
  remove: (id) => api('DELETE', `/v1/reviews/${enc(id)}`),
  report: (id, body) => api('POST', `/v1/reviews/${enc(id)}/report`, body),
  ofWorkshop: (workshopId, page = 1) => api('GET', `/v1/showcase/workshops/${enc(workshopId)}/reviews?page=${page}`),
  // oficina
  received: () => api('GET', '/v1/workshops/mine/reviews'),
  reply: (id, text) => api('POST', `/v1/workshops/mine/reviews/${enc(id)}/reply`, { text }),
};

export const RATING_LABEL = ['', 'Ruim', 'Regular', 'Bom', 'Muito bom', 'Excelente'];

/** "há 3 dias", "hoje", "há 2 meses" */
export function ago(date) {
  const days = Math.floor((Date.now() - new Date(date).getTime()) / 864e5);
  if (days < 1) return 'hoje';
  if (days === 1) return 'ontem';
  if (days < 30) return `há ${days} dias`;
  const months = Math.floor(days / 30);
  if (months < 12) return `há ${months} ${months === 1 ? 'mês' : 'meses'}`;
  const y = Math.floor(months / 12);
  return `há ${y} ${y === 1 ? 'ano' : 'anos'}`;
}

/** "respondem em cerca de 1 dia" a partir da mediana em horas. */
export function replyTime(hours) {
  if (hours === null || hours === undefined) return null;
  if (hours < 12) return { value: 'no mesmo dia', label: 'para responder avaliações' };
  const d = Math.max(1, Math.round(hours / 24));
  return { value: `${d} ${d === 1 ? 'dia' : 'dias'}`, label: 'para responder avaliações' };
}
